var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVulcavo = function SvgVulcavo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-20": 15,
    "data-width-24": 18,
    viewBox: "0 0 12.286 11.429",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 11.429C.714 8.57 1 5.714 1 2h2.286c0 3.714-.143 6.571-.715 9.429zM7.572 0H4.714v11.429h2.858zM12.286 11.429c-.715-2.858-1-5.715-1-9.429H9c0 3.714.143 6.571.714 9.429z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVulcavo);
export default ForwardRef;